// extracted by mini-css-extract-plugin
export default {"group_wrapper":"RadioGroup_group_wrapper__ZuIEj","choice":"RadioGroup_choice__3uJQv","large":"RadioGroup_large__a4ehH"};